import React from 'react';
import {useStyles} from "./ValueIndicationList.css";
import Paper from "@mui/material/Paper";
import {Divider} from "@mui/material";

export default function ValueIndicationList({
                                                headerText,
                                                headerIcon,
                                                labelValueList,
                                                primaryLabelSelector = 'label',
                                                primaryValueSelector = 'count',

                                                // Length of secondaryValueSelectors, secondaryIcons and secondaryColors must be equal
                                                secondaryValueSelectors = [],
                                                secondaryIcons = [],
                                                secondaryColors = [],


                                            }) {
    const classes = useStyles()

    return <Paper className={classes.listPaper}>

        {/* Header icon and text shown at the very left side */}
        <div className={classes.listHeader}>
            {headerIcon}
            <div>
                {headerText}
            </div>
        </div>

        {labelValueList?.map((labelCountEntry) => (
            <div key={labelCountEntry.label}
                 className={classes.numberDescriptionContainer}>

                {/* Group description */}
                <div className={classes.description}>
                    {labelCountEntry[primaryLabelSelector]}
                </div>

                {/* Value of the group */}
                <div className={classes.row}>

                    {/* Primary value (big number) */}
                    <div className={classes.number}>
                        {labelCountEntry[primaryValueSelector]}
                    </div>

                    {/* Secondary values: column consisting of icon+value rows */}
                    <div>
                        {secondaryValueSelectors.map((secondaryValue, index) => (
                            <div>
                                <div className={classes.row}>
                                    <div style={{color: secondaryColors[index]}}>
                                        {secondaryIcons[index]}
                                    </div>
                                    <div style={{color: secondaryColors[index]}}>
                                        {labelCountEntry[secondaryValue]}
                                    </div>
                                </div>
                                {(index < secondaryValueSelectors.length - 1) &&
                                <Divider className={classes.divider} orientation="horizontal"/>}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        ))}
    </Paper>
}